module.exports = __webpack_public_path__ + "assets/images/bg_c97de0966d8e9803296782a8532719b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 211
// module chunks = 0